import { Component } from '@angular/core';
import { AuthDisplayerService } from 'src/app/application/usesCases/auth-displayer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'src/app/domain/models/auth.model';
import { AuthDataService } from 'src/app/infraestructure/ui/services/auth-data.service';
@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent {
  customButtonStyles: object = {};
  disabledButton: boolean = true;
  newPassword: string = '';
  passwordConfirmation: string = '';
  userToken: string = '';
  errorToastOptions = {
    isShowing : false,
    toastTime : 5000
  }
  succesToastOptions = {
    isShowing : false,
    toastTime : 5000
  }

  constructor(
    private authDisplayerService: AuthDisplayerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authDataService: AuthDataService
    ){}

  ngOnInit(): void{
    this.activatedRoute.queryParams.subscribe(params => {
      this.userToken = params['token'];
    });
  }

  onChangeNewPassword(event: Event): void {
    this.newPassword = (event as CustomEvent).detail;
    this.disabledButton = !this.validFiels();
  }

  onChangePasswordConfirm(event: Event): void {
    this.passwordConfirmation = (event as CustomEvent).detail;
    this.disabledButton = !this.validFiels();
  }

  validFiels(): boolean {
    if (this.newPassword == '') return false;
    if (this.passwordConfirmation == '') return false;
    if ( this.newPassword === this.passwordConfirmation ) {
      return true;
    } else {
      return false;
    }
  }

  recoverPassword(): void{
    this.authDisplayerService
      .askPasswordRecovery(this.newPassword, this.passwordConfirmation, this.userToken)
      .subscribe({
        next: (data: any) => {
          const dataUser: Auth = data.user;
          this.disabledButton = true;
          this.showSuccesToast();
          this.authDataService.saveToken(dataUser.token);
          this.authDataService.saveUserData(dataUser);
          setTimeout(() => {
            this.router.navigateByUrl('/');
          }, 2000);
        },
        error: (error: any) => {
          this.showErrorToast();
        },
      });
    
  }

  showErrorToast(): void {
    this.errorToastOptions.isShowing = true;
  }

  closingErrorToast(): void{
    this.errorToastOptions.isShowing = false;
  }

  showSuccesToast(): void {
    this.succesToastOptions.isShowing = true;
  }

  closingSuccesToast(): void{
    this.succesToastOptions.isShowing = false;
  }

  getErrorMessage(): string{
    if (this.newPassword !== '' && this.passwordConfirmation !== '') {
      if (this.newPassword !== this.passwordConfirmation) {
        return 'Las contraseñas no coinciden';
      } else return '';
    } else return '';
  }
}
